import React, { useMemo, useRef, useState } from 'react';
import type { Entry, Quadrant, Ring } from '../../utils/types';
import RadarPlot from '../RadarPlot';
import { adjustEntries, adjustQuadrants, adjustRings } from './utils';

export type Props = {
  width: number;
  height: number;
  quadrants: Quadrant[];
  rings: Ring[];
  entries: Entry[];
  svgProps?: object;
};

const Radar = ({
  width,
  height,
  quadrants,
  rings,
  entries,
  ...props
}: Props): JSX.Element => {
  // Radius with optional buffer for the footer if rings have descriptions
  const radius =
    Math.min(width, height) / 2 -
    (rings.some(ring => ring.description) ? 16 : 0);

  // State
  const [activeEntry, setActiveEntry] = useState<Entry>();
  const node = useRef<SVGSVGElement>(null);

  // Adjusted props
  const adjustedQuadrants = useMemo(
    () => adjustQuadrants(quadrants, radius, width, height),
    [quadrants, radius, width, height],
  );
  const adjustedRings = useMemo(
    () => adjustRings(rings, radius),
    [radius, rings],
  );
  const adjustedEntries = useMemo(
    () =>
      adjustEntries(
        entries,
        adjustedQuadrants,
        adjustedRings,
        radius,
        activeEntry,
      ),
    [entries, adjustedQuadrants, adjustedRings, radius, activeEntry],
  );
  console.log(adjustedEntries, adjustedRings, adjustedQuadrants);

  return (
    <svg ref={node} width={width} height={height} {...props.svgProps}>
      <RadarPlot
        width={width}
        height={height}
        radius={radius}
        entries={adjustedEntries}
        quadrants={adjustedQuadrants}
        rings={adjustedRings}
        activeEntry={activeEntry}
        onEntryMouseEnter={entry => setActiveEntry(entry)}
        onEntryMouseLeave={() => setActiveEntry(undefined)}
      />
    </svg>
  );
};

export default Radar;
